import { createSlice  } from '@reduxjs/toolkit'
import { getPageFilter, saveFilters } from 'utils';

const initialState = {
    leaveCreditForecastList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: getPageFilter('leaveCreditForecastList'),
    },
    leaveCreditForecastDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
  };

export const leaveCreditForecastSlice = createSlice({
  name: 'leaveCreditForecast',
  initialState,
  reducers: {
    getLeaveCreditForecastList: (state, action) => {
        state.leaveCreditForecastList.requesting = true;
        state.leaveCreditForecastList.error = null;
        state.leaveCreditForecastList.items = [];
        state.leaveCreditForecastList.success = false;
        state.leaveCreditForecastList.filters = action.payload;
        saveFilters('leaveCreditForecastList', action.payload);
    },
    getLeaveCreditForecastListSuccess: (state, action) => {
        const { data, current_page, per_page, total} = action.payload;   
        state.leaveCreditForecastList.requesting = false;
        state.leaveCreditForecastList.items = data;
        state.leaveCreditForecastList.success = true; 
        state.leaveCreditForecastList.pagination.current_page = current_page;
        state.leaveCreditForecastList.pagination.per_page = per_page;
        state.leaveCreditForecastList.pagination.total = total;
    },
    getLeaveCreditForecastListFail: (state, action) => {        
        state.leaveCreditForecastList.requesting = false;
        state.leaveCreditForecastList.error = action.payload;
    },
    getLeaveCreditForecastDetails: (state) => {
        state.leaveCreditForecastDetails.requesting = true;
        state.leaveCreditForecastDetails.error = null;
        state.leaveCreditForecastDetails.data = null;
        state.leaveCreditForecastDetails.success = false; 
    },
    getLeaveCreditForecastDetailsSuccess: (state, action) => {
        state.leaveCreditForecastDetails.requesting = false;
        state.leaveCreditForecastDetails.data = action.payload;
        state.leaveCreditForecastDetails.success = true; 
    },
    getLeaveCreditForecastDetailsFail: (state, action) => {        
        state.leaveCreditForecastDetails.requesting = false;
        state.leaveCreditForecastDetails.error = action.payload;
    },
  },
})

export const { 
    getLeaveCreditForecastList, getLeaveCreditForecastListSuccess, getLeaveCreditForecastListFail,
    getLeaveCreditForecastDetails, getLeaveCreditForecastDetailsSuccess, getLeaveCreditForecastDetailsFail,
} = leaveCreditForecastSlice.actions

export default leaveCreditForecastSlice.reducer